module.exports = __webpack_public_path__ + "img/silver.5d5d539f.png";